import { render, staticRenderFns } from "./employer_aipp.vue?vue&type=template&id=2e9956d0&"
import script from "./employer_aipp.vue?vue&type=script&lang=js&"
export * from "./employer_aipp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports